import { REST_API_ORIGIN } from '../platform/endpoints';

export function formatRelativeDate(value) {
  if (!value) return '';

  try {
    const date = new Date(value);
    const time = date.getTime();
    if (Number.isNaN(time)) return '';

    const now = Date.now();
    const diffMs = now - time;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHour = Math.floor(diffMs / 3600000);
    const diffDay = Math.floor(diffMs / 86400000);

    if (diffMin < 1) return 'ahora';
    if (diffMin < 60) return `hace ${diffMin} min`;
    if (diffHour < 24) return `hace ${diffHour} h`;
    if (diffDay === 1) return 'ayer';
    if (diffDay < 7) return `hace ${diffDay} d`;

    return new Intl.DateTimeFormat('es-AR', {
      day: '2-digit',
      month: 'short',
    }).format(date);
  } catch {
    return '';
  }
}

export function resolveAvatarUrl(author) {
  const raw =
    author?.avatarUrl ||
    author?.photoPath ||
    author?.profilePicture ||
    author?.profilePhoto ||
    author?.profileImage ||
    author?.avatar ||
    author?.image ||
    author?.photo ||
    author?.photoURL ||
    '';

  const value = String(raw || '').trim();
  if (!value) return '';

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  return `${REST_API_ORIGIN}/${value.replace(/^\//, '')}`;
}
